import React, { Component } from 'react';
import { Row, Col , Button} from 'reactstrap';
import { connect } from 'react-redux';
import { Preloading } from '../../../components/UI/Preloader/action';
import { fetchCUGPortfolioRequest, saveCUGCorporateData } from './action';
import {  getRiskObject} from './cug-charts/util'

class CUGPortfolioTable extends Component {

    state = { cugPortfoliioList : {} , currentPage: parseInt(this.props.match.params.pageNumber) - 1};
  
    componentDidMount() {
      this.props.preloading(true);
      this.props.fetchCUGPortfolioRequest(this.state.currentPage);
    }
  
    handleOnCLick = (p) => {
      this.props.saveCUGCorporateData(p);
      let url = `/cug-report/${p.corporateId}/${p.counterpartyId}/${p.cugId}`;
      this.props.history.push(url);
    }
  
    componentDidUpdate(prevProps) {
      if(prevProps.cugPortfoliioList !== this.props.cugPortfoliioList){
        this.props.preloading(false);
        this.setState({cugPortfoliioList : this.props.cugPortfoliioList });
      }
    }

    getRiskGrade = (score) => {
      let riskObject = getRiskObject(score);
      return riskObject.grade;
    }

    getCompanyName = (p) => {
      if(p && p.parentCompanyName && p.parentCompanyName.trim().length > 0 ){
        return p.parentCompanyName;
      }else if(p && p.counterpartyName && p.counterpartyName.trim().length > 0 ){
        return p.counterpartyName;
      }
      return "";
    }
  
    render() {
      return (
        this.state.cugPortfoliioList 
        && this.state.cugPortfoliioList.cugReportList && this.state.cugPortfoliioList.cugReportList.length  > 0 ? this.state.cugPortfoliioList.cugReportList.map(p => {
          return (
            <Row key={p.id}  onClick ={ ()=> this.handleOnCLick(p)}noGutters className="bg-light border-bottom p-3 p-sm-0 mb-3 mb-sm-0">
              <Col className="custom-table-col "> <span className="d-inline-block" > <Button color="link">{this.getCompanyName(p) }</Button></span> </Col>
              <Col className="custom-table-col ml-3"> <span className="d-inline-block" >{p.paymentScore  }</span> </Col>
              <Col className="custom-table-col"> <span className="d-inline-block" >{ this.getRiskGrade(p.paymentScore)}</span> </Col> 
            </Row>
          )
        }) : <div className="text-center"> No data Found ! </div>
      )
    }
  }
  
  const mapStateToProps = (state) => ({ cugPortfoliioList: state.cugPortfolio.cugPortfoliioList });
  
  const mapDispatchToProps = dispatch => ({
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    fetchCUGPortfolioRequest: (data) => { dispatch(fetchCUGPortfolioRequest(data)) },
    saveCUGCorporateData : (data) => {dispatch(saveCUGCorporateData(data))}
  });
  
  export default connect(mapStateToProps, mapDispatchToProps)(CUGPortfolioTable);